import { render, staticRenderFns } from "./Infinity.vue?vue&type=template&id=3979b24d&scoped=true"
import script from "./Infinity.vue?vue&type=script&lang=ts"
export * from "./Infinity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979b24d",
  null
  
)

export default component.exports